// export default AddSyllabusForm;
import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
} from "@mui/material";
import { SyllabusUpload } from "./componets/syllabus-upload";
import { SubjectSelection } from "./componets/subject-chap-topic";
import { useHistory, useRouteMatch } from "react-router-dom";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import myClassroomClient from "utils/graphql/myclassroom";
import {
  GET_SCHEDULE_SYLLABUS_CONTEXT,
  GET_SCHEDULE_SYLLABUS_DETAILS,
  GET_SCHEDULE_SYLLABUS_FULL_DATA,
} from "utils/graphql/services/exam-schedule/queries";
import { isEmpty } from "utils/helpers";
import { CREATE_SCHEDULE_SYLLABUS, UPDATE_SCHEDULE_SYLLABUS } from "utils/graphql/services/exam-schedule/mutations";
import { useAppDispatch } from "hooks/redux";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { mergeSubjectsWithContentHierarchy, transformData, transformSubjectData } from "../helper";
import ContentRight from "shared/molecules/content-right";
import LoadingButton from "@mui/lab/LoadingButton";
import _ from "lodash";


interface Subject {
  subject_id: string; // e.g. "5nrMDHSMZu"
  subject_name: string; // e.g. "GK"
  chapter_list: Chapter[]; // list of chapters
  topic_list: Topic[]; // list of topics
}

interface Chapter {
  chapter_id: string;
  chapter_name: string;
  // add other properties if available
}

interface Topic {
  topic_id: string;
  topic_name: string;
  // add other properties if available
}

const GET_SIGNED_DOWNLOAD_URL = gql`
  query GetSignedDownloadUrl($filename: String!) {
    getSignedDownloadUrl(filename: $filename) {
      signedUrl
      filename
      expiresAt
    }
  }
`;

// Main Component
export const AddSyllabusForm = ({
  //subjects = subjectsData, // Pre-filled subjects array
  onSave,
}) => {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [syllabusUrl, setSyllabusUrl] = useState("");
  const [modifiedData, setModifiedData] = useState<Record<string, Subject>>({});
  const [payloadData, setPayloaddata] = useState({});
  const [isCreate, setIsCreate] = useState(true);
  const [createLoad, setCreateLoad] = useState(false);
  const [subjectSelections, setSubjectSelections] = useState([]);
  const [globalClass,setGlobalClass]=useState<string[]>([]);
  const [globalCourseIds,setGlobalCourseIds]=useState<string[]>([]);
  const dispatch = useAppDispatch();
  const match: any = useRouteMatch();
  const history = useHistory();

  const [
    getScheduleSubjects,
    { loading: loadingSy, error: errorSy, data: dataSub },
  ] = useLazyQuery(GET_SCHEDULE_SYLLABUS_CONTEXT, {
    client: myClassroomClient,
    fetchPolicy: "no-cache",
  });

  const [
    getScheduleSyllabusDeatails,
    { loading: loadingDetails, error: errorDetails, data: dataDetails },
  ] = useLazyQuery(GET_SCHEDULE_SYLLABUS_DETAILS, {
    client: myClassroomClient,
    fetchPolicy: "no-cache",
  });

  const [
    getScheduleSyllabusFullData,
    { loading: loadingFullData, error: errorFullData, data: dataSyllabusFullData },
  ] = useLazyQuery(GET_SCHEDULE_SYLLABUS_FULL_DATA, {
    client: myClassroomClient,
    fetchPolicy: "no-cache",
  });

  const [createSchduleSyllabus, { loading, error, data }] = useMutation(
    CREATE_SCHEDULE_SYLLABUS,
    {
      client: myClassroomClient,
    }
  );
  const [updateSchduleSyllabus, { loading:loadingUp, error:errorUp, data:dataUp }] = useMutation(
    UPDATE_SCHEDULE_SYLLABUS,
    {
      client: myClassroomClient,
    }
  );

   const [getSignedDownloadUrl, { loading: loadingGetSigDowUrl, error: errorGetSigDowUrl, data: dataGetSigDowUrl }] =
    useLazyQuery(GET_SIGNED_DOWNLOAD_URL, {
      client: myClassroomClient,
    });

  const handleFileUpload = (file) => {
     setUploadedFile(file?.filename);
  };

  const getContentHirearchy=()=>{
    const paylaod=Object.values(payloadData);
    return Object.values(payloadData).flatMap((sub:any) => sub.chapter_Topic_list || []);
  }

const handleSave = async () => {
  setCreateLoad(true);

  const uniqueData = _.uniqBy<any>(
  getContentHirearchy(),
  item => `${item.chapter_id}-${item.topic_id}`
);

  try {
    let response: any;

    if (isCreate) {
      // CREATE flow
      response = await createSchduleSyllabus({
        variables: {
          input: {
            schedule_id: match?.params?.schdule_id,
            syllabus_public_pdf_url:uploadedFile,
            content_hierarchies: uniqueData,
          },
        },
      });

      if (!isEmpty(response?.data?.createScheduleSyllabus)) {
        dispatch(
          snackbarRequest({ message: "Created syllabus successfully" })
        );
        history.replace(`/exam_schedule/list`);
      } else {
        dispatch(
          snackbarRequest({
            message: `${response?.errorReason}`,
            type: "error",
          })
        );
      }
    } else {
      // UPDATE flow
      response = await updateSchduleSyllabus({
        variables: {
          input: {
            schedule_id: match?.params?.schdule_id,
            syllabus_public_pdf_url:uploadedFile,
            content_hierarchies: uniqueData,
          },
        },
      });

      if (!isEmpty(response?.data?.updateScheduleSyllabus)) {
        dispatch(
          snackbarRequest({ message: "Updated syllabus successfully" })
        );
        history.replace(`/exam_schedule/list`);
      } else {
        dispatch(
          snackbarRequest({
            message: `${response?.errorReason}`,
            type: "error",
          })
        );
      }
    }
  } catch (err: any) {
    dispatch(snackbarRequest({ message: `${err?.message}`, type: "error" }));
  } finally {
    setCreateLoad(false);
  }
};

  const handlePayload = (stringId, chapter_Topic_list) => {
    setPayloaddata((prev) => ({
      ...prev,
      [stringId]: {
        ...(prev[stringId] || {}), 
        chapter_Topic_list, 
      },
    }));
  };

  // useEffect(() => {
  //   const hierarchies =
  //     dataDetails?.getScheduleSyllabusDetails?.content_hierarchies;
  //   const subjectContent =
  //     dataDetails?.getScheduleSyllabusDetails?.subjects;
  //   const subjects = dataSub?.getScheduleSyllabusContext?.subjects;
  //   const globalClassIds= dataSub?.getScheduleSyllabusContext?.class_ids
  //   const globalCourseIds= dataSub?.getScheduleSyllabusContext?.course_ids
  //   let transformed: any = null;

  //   if (!isEmpty(hierarchies)) {
  //    // transformed = transformData(hierarchies);
  //     transformed = mergeSubjectsWithContentHierarchy(subjectContent,hierarchies);
  //     setUploadedFile(dataDetails?.getScheduleSyllabusDetails?.syllabus_public_pdf_url)
  //     setIsCreate(false);
  //   } else if (!isEmpty(subjects)) {
  //     transformed = transformSubjectData(subjects);
  //   }
  //   setGlobalClass(globalClassIds)
  //   setGlobalCourseIds(globalCourseIds)

  //   if (transformed) {
  //     setModifiedData(transformed);
  //     setPayloaddata(transformed);
  //   }
  // }, [dataDetails, dataSub]);

  useEffect(() => {
    const hierarchies =
      dataSyllabusFullData?.getScheduleSyllabusDetails?.content_hierarchies;
    const subjectContent =
      dataSyllabusFullData?.getScheduleSyllabusDetails?.subjects;
    const subjects = dataSyllabusFullData?.getScheduleSyllabusContext?.subjects;
    const globalClassIds= dataSyllabusFullData?.getScheduleSyllabusContext?.class_ids
    const globalCourseIds= dataSyllabusFullData?.getScheduleSyllabusContext?.course_ids
    let transformed: any = null;

    if (!isEmpty(hierarchies)) {
     // transformed = transformData(hierarchies);
      transformed = mergeSubjectsWithContentHierarchy(subjectContent,hierarchies);
      setUploadedFile(dataSyllabusFullData?.getScheduleSyllabusDetails?.syllabus_public_pdf_url)
      setIsCreate(false);
    } else if (!isEmpty(subjects)) {
      transformed = transformSubjectData(subjects);
    }
    setGlobalClass(globalClassIds)
    setGlobalCourseIds(globalCourseIds)

    if (transformed) {
      setModifiedData(transformed);
      setPayloaddata(transformed);
    }
  }, [dataSyllabusFullData]);

  useEffect(() => {
    // getScheduleSubjects({
    //   variables: {
    //     schedule_id: match?.params?.schdule_id,
    //   },
    // });
    // getScheduleSyllabusDeatails({
    //   variables: {
    //     schedule_id: match?.params?.schdule_id,
    //   },
    // });
    getScheduleSyllabusFullData({
      variables: {
        schedule_id: match?.params?.schdule_id,
      },
    })
  }, []);

  return (
    <Box sx={{ maxWidth: "100%", mx: "auto", p: 3 }}>
      <Paper sx={{ p: 4, border: "2px solid #1976d2", borderRadius: 2 }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: 500 }}>
          Add Syllabus
        </Typography>

        {/* Syllabus Upload Component */}
        <SyllabusUpload onFileUpload={handleFileUpload} initialFileName={uploadedFile} />

        {/* Fixed Subject Selections */}
        <Box sx={{ mb: 4 }}>
          {!isEmpty(Object.values(modifiedData)) &&
            Object.values(modifiedData)?.map((subject, index) => (
              <SubjectSelection
                key={subject?.subject_id}
                subjectNumber={index + 1}
                subjectData={subject}
                handlePayload={handlePayload}
                isCreate={isCreate}
                globalClass={globalClass}
                globalCourseIds={globalCourseIds}
              />
            ))}
        </Box>

           <ContentRight sx={{ mt: -1 }}>
                <LoadingButton
                  variant="contained"
                  loadingPosition="start"
                  loading={createLoad}
                  sx={{
                    width: "180px",
                    height: "40px",
                    marginTop: "15px",
                    marginRight: "10px",
                    padding: "7px 23.5px 7px 23.5px",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                  onClick={handleSave}
                  disabled={(hasEmptyChapterTopicList(Object.values(payloadData)) || isEmpty(uploadedFile) )}
                >
                 {isCreate?"Create":"Update"}
                </LoadingButton>
              </ContentRight>
      </Paper>
    </Box>
  );
};

export default AddSyllabusForm;

function hasEmptyChapterTopicList(subjects) {
  return subjects?.some(subject => 
    Array.isArray(subject?.chapter_Topic_list) && subject?.chapter_Topic_list.length === 0
  );
}

